var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8192 7.59961H11.8692V8.69961H16.2692V21.8997H1.96914V8.69961H6.36916V7.59961H1.41914C1.11552 7.59961 0.869141 7.84599 0.869141 8.14961V22.4497C0.869141 22.7533 1.11552 22.9997 1.41914 22.9997H16.8192C17.1228 22.9997 17.3692 22.7533 17.3692 22.4497V8.14961C17.3692 7.84604 17.1228 7.59961 16.8192 7.59961Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8029 4.38516L9.50291 1.15665C9.28622 0.944343 8.93753 0.948382 8.72522 1.16546L5.43402 4.38482C5.21694 4.59747 5.2129 4.94544 5.42521 5.1629C5.63752 5.37925 5.98621 5.38329 6.2029 5.17098L8.56864 2.85693V14.6776C8.56864 14.9816 8.81503 15.2276 9.11864 15.2276C9.42226 15.2276 9.66865 14.9819 9.66865 14.6776V2.85689L12.034 5.17094C12.2507 5.38359 12.5994 5.37955 12.8117 5.16286C13.024 4.94544 13.0203 4.59743 12.8029 4.38516Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.68b14ff411df3b607834f95204b7f7b5.svg";
export { ForwardRef as ReactComponent };